import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';

function useFetchEsimPackages({country}: {country?: string}) {
  const {getEsimPackages} = useChekinSDK();

  const result = useQuery({
    queryKey: [QUERY_CACHE_KEYS.esimPackages, country],
    queryFn: () => getEsimPackages({}, `country=${country}`),
    enabled: Boolean(country),
  });

  return result;
}

export {useFetchEsimPackages};
